import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import VideoUploadButton from './components/VideoUploadButton';
import VideoUploader from './handler/VideoUploader';
import ImageUploadButton from './components/ImageUploadButton';

app.initializers.add('tf-cns-upload-video-forum', () => {
  // 覆盖 fof-upload 的 UploadButton 组件，添加 accept="image/*" 属性
  // 在 controlItems 中替换 fof-upload 的按钮，使用我们自己的 ImageUploadButton
  extend(TextEditor.prototype, 'controlItems', function(items) {
    // 检查是否存在 fof-upload 按钮
    if (items.has('fof-upload')) {
      // 获取 fof-upload 的 uploader 实例
      const fofUploader = this.uploader;
      
      // 替换为我们的 ImageUploadButton（带 accept="image/*" 限制）
      items.replace(
        'fof-upload',
        ImageUploadButton.component({
          uploader: fofUploader,
        })
      );
    }
  }, 100); // 使用较高的优先级，确保在 fof-upload 之后执行
  // 添加上传视频按钮到 TextEditor
  extend(TextEditor.prototype, 'oninit', function() {
    // 初始化自定义视频上传器
    if (!this.videoUploader) {
      this.videoUploader = new VideoUploader();
    }
    
    // 初始化状态跟踪
    this.lastTagIds = null; // 用于跟踪上次选中的 tag IDs
  });

  // 监听 composer 的 tag 选择变化
  extend(TextEditor.prototype, 'oncreate', function() {
    const composer = this.attrs.composer;
    if (!composer) return;
    
    // 监听 composer 的 fields 变化
    const checkTags = () => {
      const currentTagIds = this.getCurrentTagIds();
      const lastTagIds = this.lastTagIds;
      
      // 如果 tag 选择发生变化，触发重新渲染
      if (JSON.stringify(currentTagIds) !== JSON.stringify(lastTagIds)) {
        this.lastTagIds = currentTagIds;
        // 使用 setTimeout 确保在下一个渲染周期更新
        setTimeout(() => {
          m.redraw();
        }, 0);
      }
    };
    
    // 定期检查 tag 变化（因为 Flarum 可能不会直接触发事件）
    this.tagCheckInterval = setInterval(checkTags, 200);
    
    // 初始检查
    checkTags();
  });

  extend(TextEditor.prototype, 'onremove', function() {
    // 清理定时器
    if (this.tagCheckInterval) {
      clearInterval(this.tagCheckInterval);
      this.tagCheckInterval = null;
    }
  });

  // 辅助方法：获取当前选中的 tag IDs
  extend(TextEditor.prototype, 'getCurrentTagIds', function() {
    const composer = this.attrs.composer;
    let tags = [];
    
    if (composer) {
      if (composer.fields && composer.fields.tags) {
        tags = composer.fields.tags;
      } else if (composer.discussion) {
        const discussion = composer.discussion;
        tags = discussion.tags() || [];
      }
    }
    
    return tags.map(tag => tag.id()).filter(id => id).sort();
  });

  extend(TextEditor.prototype, 'controlItems', function(items) {
    const user = app.session.user;
    if (!user) {
      return;
    }

    // 检查是否是管理员
    const isAdmin = user.attribute('isAdmin');
    
    // 获取选中的tags
    const composer = this.attrs.composer;
    let tags = [];
    
    if (composer) {
      if (composer.fields && composer.fields.tags) {
        // 新讨论：从composer.fields.tags获取
        tags = composer.fields.tags;
      } else if (composer.discussion) {
        // 已存在的讨论：从discussion.tags()获取
        const discussion = composer.discussion;
        tags = discussion.tags() || [];
      }
    }
    
    // 检查是否任一tag的isModerator为true
    let isTagModerator = false;
    
    if (tags && tags.length > 0) {
      isTagModerator = tags.some(tag => {
        const isMod = tag.attribute('isModerator');
        return isMod === true;
      });
    }

    // 显示按钮的条件：
    // 1. 是管理员，或者
    // 2. 是tag的版主（任一选中的tag的isModerator为true）
    const shouldShow = isAdmin || isTagModerator;
    
    if (shouldShow) {
      items.add(
        'tf-video-upload',
        VideoUploadButton.component({
          uploader: this.videoUploader,
          composer: this.attrs.composer,
        }),
        0// 优先级，放在 fof-upload (0) 之前
      );
    }
  });
})